import { Soundwave } from 'types';
import { defaultSoundwaveState } from 'utils/embed/soundwave';
import { MINUTE_IN_SECONDS } from 'utils/time';

export const CHILD_VIEW_ZOOM_DURATION_MS = 300;
export const CHILD_VIEW_ZOOM_DELAY_MS = 300;

export const DYNAMIC_VIDEO_AUTOFRAME_TOOLTIP_MESSAGE =
  'Turn AutoFrame off to manually adjust size and position';

export const AUTOFRAME_MAX_VIDEO_DURATION_SECONDS = 3 * MINUTE_IN_SECONDS; // 3 minutes.

export const DEFAULT_SOUNDWAVE_STATE: Readonly<Soundwave> = {
  ...defaultSoundwaveState.toJS(),
  waveGeneration: 'amplitudeBased',
  waveType: 'roundBars',
};
